import { z } from 'zod'

import { publicEnvSchema, validatePublicEnv } from './env.schema.mjs'

export type PublicEnv = z.infer<typeof publicEnvSchema>

export { publicEnvSchema, validatePublicEnv }

export const publicEnv = validatePublicEnv({
  NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
  NEXT_PUBLIC_HAFIZ_BASE_URL: process.env.NEXT_PUBLIC_HAFIZ_BASE_URL,
  NEXT_PUBLIC_R2_BASE_URL: process.env.NEXT_PUBLIC_R2_BASE_URL,
  NEXT_PUBLIC_HAFIZ_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_HAFIZ_TURNSTILE_SITE_KEY,
})
